import { postJson } from "./request";
// 郵箱驗證
export const fetchVerifyEmail = async (key, apiKey) => {
  const url = `https://identitytoolkit.googleapis.com/v1/accounts:update?key=${apiKey}`;
  return await postJson({
    url, params: {
      oobCode: key
    }, options: { allowStatus: 400 }
  });
}

// reset_password 01_驗證token
export const fetchVerifyToken = async (key, apiKey) => {
  const url = `https://identitytoolkit.googleapis.com/v1/accounts:resetPassword?key=${apiKey}`;
  return await postJson({
    url, params: {
      oobCode: key,
    }, options: { allowStatus: 400 }
  });
}
// reset_password 02_重置密碼 (先驗證否則會報錯)
export const fetchResetPassword = async (key, password, apiKey) => {
  const url = `https://identitytoolkit.googleapis.com/v1/accounts:resetPassword?key=${apiKey}`;
  return await postJson({
    url, params: {
      oobCode: key,
      newPassword: password,
    }, options: { allowStatus: 400 }
  });
}